export default {
  getUseCaseRequestedStep: function getUseCaseRequestedStep(state) {
    return state.useCaseRequest.step;
  },
  getUseCaseRequestBaseIDS: function getUseCaseRequestBaseIDS(state) {
    return state.useCaseRequest.baseIDS || [];
  }
};